import React, { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import api from '../api'

export default function CheckEmail() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const email = searchParams.get('email') || ''
  const [resendLoading, setResendLoading] = useState(false)
  const [resendSent, setResendSent] = useState(false)

  const handleResend = async () => {
    if (resendLoading || resendSent) return
    setResendLoading(true)
    try {
      await api.post('/auth/resend-verification', { email })
      setResendSent(true)
    } catch (err) {
      console.error('Resend failed', err)
    } finally {
      setResendLoading(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--cream)',
      display: 'flex', alignItems: 'center',
      justifyContent: 'center', padding: '24px',
    }}>
      <div style={{ width: '100%', maxWidth: '460px', textAlign: 'center' }}>

        <div
          onClick={() => navigate('/')}
          style={{
            fontFamily: 'var(--font-display)', fontSize: '28px',
            fontWeight: 700, color: 'var(--navy)',
            marginBottom: '40px', cursor: 'pointer',
          }}
        >
          Velu<span style={{ color: 'var(--gold)' }}>mio</span>
        </div>

        <div style={{
          background: 'var(--white)', borderRadius: 'var(--radius-lg)',
          padding: '48px 40px', boxShadow: 'var(--shadow-md)',
          border: '1px solid var(--cream-dark)',
        }}>
          <div style={{ fontSize: '64px', marginBottom: '24px' }}>📬</div>

          <h2 style={{
            fontFamily: 'var(--font-display)', fontSize: '24px',
            color: 'var(--navy)', marginBottom: '12px',
          }}>
            Almost there. Check your inbox.
          </h2>

          <p style={{
            fontSize: '15px', color: 'var(--muted)',
            lineHeight: 1.7, marginBottom: '8px',
          }}>
            We sent a verification link to
          </p>

          <p style={{
            fontSize: '15px', fontWeight: 600,
            color: 'var(--navy)', marginBottom: '24px',
            wordBreak: 'break-word' as const,
          }}>
            {email || 'your email address'}
          </p>

          <div style={{
            padding: '18px', background: 'rgba(200,150,62,0.1)',
            border: '1px solid rgba(200,150,62,0.3)',
            borderRadius: 'var(--radius-md)', marginBottom: '24px',
            fontSize: '14px', color: 'var(--ink-soft)',
            lineHeight: 1.7, textAlign: 'left' as const,
          }}>
            <strong style={{ color: 'var(--navy)' }}>You must verify your email before you can log in.</strong>
            <br />
            Click the link in the email we just sent. If you do not see it within
            a few minutes, check your spam or junk folder.
          </div>

          {resendSent ? (
            <p style={{
              fontSize: '14px', color: 'var(--green)',
              marginBottom: '20px', fontWeight: 500,
            }}>
              A new verification link has been sent.
            </p>
          ) : (
            <button
              onClick={handleResend}
              disabled={resendLoading}
              style={{
                width: '100%', padding: '13px', fontSize: '14px',
                fontWeight: 500, color: 'var(--navy)',
                background: 'transparent',
                border: '1.5px solid var(--warm-border)',
                borderRadius: 'var(--radius-md)',
                cursor: resendLoading ? 'not-allowed' : 'pointer',
                fontFamily: 'var(--font-body)', marginBottom: '12px',
              }}
            >
              {resendLoading ? 'Sending...' : 'Resend verification email'}
            </button>
          )}

          <button
            onClick={() => navigate('/login')}
            style={{
              width: '100%', padding: '13px', fontSize: '14px',
              fontWeight: 600, color: 'var(--white)',
              background: 'var(--navy)', border: 'none',
              borderRadius: 'var(--radius-md)',
              cursor: 'pointer', fontFamily: 'var(--font-body)',
            }}
          >
            I have verified — take me to login
          </button>
        </div>

        <p style={{
          marginTop: '24px', fontSize: '13px', color: 'var(--muted)',
        }}>
          Wrong email address?{' '}
          <span
            onClick={() => navigate('/register')}
            style={{ color: 'var(--gold)', cursor: 'pointer', fontWeight: 500 }}
          >
            Sign up again
          </span>
        </p>

      </div>
    </div>
  )
}